/** @format */

import React from 'react';

import { UserDispatcherContext } from 'providers';

function useUserDispatcher() {
  return React.useContext(UserDispatcherContext);
}

export { useUserDispatcher };
